export default {"src":"/_next/static/media/google-play-icon.41b21a0c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};